// Version : 1.0.0
// Author : AGALYA

const ResidentialDetailsActionType = {
	/** ***************** Residential Address Add Start ************************/
	RESIDENTIAL_DETAILS_ADD_START: 'residential_details_add_start',
	RESIDENTIAL_DETAILS_ADD_SUCCESS: 'residential_details_add_success',
	RESIDENTIAL_DETAILS_ADD_FAILURE: 'residential_details_add_failure',
	RESIDENTIAL_DETAILS_ADD_RESPONSE_REST_START: 'residential_details_add_response_reset_start',
	RESIDENTIAL_DETAILS_ADD_RESPONSE_CHANGED: 'residential_details_add_response_changed',
	/** ***************** Residential Address Add End ************************/
};

export default ResidentialDetailsActionType;
